import Web3 from 'web3';
import type { AbiItem } from 'web3-utils';

import LOCK_AIRI_ABI from '@/utils/abi/lock-airi.json';
import { read } from '@/utils/web3Service';

import type { PoolInfo } from './useTotalLocked';

export const getPoolConfigBatch = async (
  address: string,
  pools: Array<number>,
): Promise<{ totalLock: string; rewardPerSecond: string; durationLock: string }[]> => {
  const config = await read('getPoolConfigBatch', address, LOCK_AIRI_ABI as AbiItem[], [pools]);
  return config;
};

const getPoolLabel = (id: number) => {
  switch (id) {
    case 0:
      return '3 Months';

    case 1:
      return '6 Months';

    default:
      return '12 Months';
  }
};

export const convertDataPoolInfo = (data: { totalLock: string }[]): PoolInfo[] => {
  return data.map((lock, index) => ({
    id: index,
    label: getPoolLabel(index),
    totalLock: parseInt(Web3.utils.fromWei(lock.totalLock)),
  }));
};

export const convertDataPoolInfoWithOraiChain = (data: { total_lock: string }[]): PoolInfo[] => {
  return data.map((lock, index) => ({
    id: index,
    label: getPoolLabel(index),
    totalLock: parseFloat(lock.total_lock) * 10 ** -6,
  }));
};
